module.exports = __webpack_public_path__ + "img/logo_avatar.a565c679.svg";